import { render, staticRenderFns } from "./IconDotsCircleHorizontalOutline.vue?vue&type=template&id=560fa996"
import script from "./IconDotsCircleHorizontalOutline.vue?vue&type=script&lang=js"
export * from "./IconDotsCircleHorizontalOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports